// extracted by mini-css-extract-plugin
module.exports = {"formSeach":"form_formSeach__3aDQH","buttonSeach":"form_buttonSeach__mG5z3","legendForm":"form_legendForm__1N1TY","inputSeach":"form_inputSeach__3vu-D"};